import React from "react";
import Button from "Components/button/Button";
import { alertError } from "Utils/alerts";
// import s from "../Show.scss";
import t from "Utils/translation";

import cx from "classnames";
import s from "./dkimDomains.scss";
import QboxmailApi from "@/qboxmailApi";
import Loader from "Components/loader/Loader";

export default class DKIM extends React.Component {
  api = new QboxmailApi({ useCookie: true });

  state = {
    isVerifing: false,
    isEnabling: false,
    isResetting: false,
    isDisabling: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isDomainRefreshing && !this.props.isDomainRefreshing) {
      if (this.state.isEnabling) this.setState({ isEnabling: false });
      if (this.state.isResetting) this.setState({ isResetting: false });
      if (this.state.isDisabling) this.setState({ isDisabling: false });
      if (this.state.isVerifing) this.setState({ isVerifing: false });
    }

    /* if is enqueud refresh the info about the domain every X seconds */
    let isEnqueued = [3, 4].includes(this.props.domain.has_dkim);
    if (isEnqueued && !this.refreshScheduled) {
      this.refreshScheduled = true;
      window.setTimeout(() => {
        this.props.refreshDomain(this.props.domain.code);
        this.refreshScheduled = false;
      }, 2000);
    }
  }

  enableDKIM = async (e) => {
    e.preventDefault();

    this.setState({ isEnabling: true });

    const { resources } = await this.api.enableDKIM(this.props.domain.code).catch((e) => {
      console.log("Error while enabling dkim", e);
      alertError("Attivazione DKIM fallita");
      this.setState({ isEnabling: false });
    });

    if (resources) this.props.refreshDomain(this.props.domain.code);
  };

  disableDKIM = async (e) => {
    e.preventDefault();

    this.setState({ isDisabling: true });

    await this.api.disableDKIM(this.props.domain.code).catch((e) => {
      console.log("Error while disabling dkim", e);
      this.setState({ isDisabling: false });
      alertError(t("settings.alert.dkim.disableFailed"));
    });

    this.props.refreshDomain(this.props.domain.code);
  };

  resetDKIM = async (e) => {
    e.preventDefault();

    this.setState({ isResetting: true });

    await this.api.resetDKIM(this.props.domain.code).catch((e) => {
      console.log("Error while resetting dkim", e);
      this.setState({ isResetting: false });
      alertError(t("settings.alert.dkim.resetFailed"));
    });

    this.props.refreshDomain(this.props.domain.code);
  };

  verifyDKIM = async (e) => {
    e.preventDefault();

    this.setState({ isVerifing: true });

    await this.api.verifyDKIM(this.props.domain.code).catch((e) => {
      console.log("Error while verifing dkim", e);
      alertError(t("settings.alert.dkim.verifyFailed"));
      this.setState({ isVerifing: false });
    });

    this.props.refreshDomain(this.props.domain.code);
  };

  renderDisabled = () => {
    return (
      <div className="sectionSP">
        <div className="infoSectionSP">
          <div className="settingTitle">{t("settings.sections.dkim.title")}</div>
          <div className="sectionDesc">{t("settings.sections.dkim.desc")}</div>
        </div>
        <div className="formsSectionSP">
          <div className={cx(s.infoText, "inputFull2")}>{t("description.text.disabledDKIM")}</div>
          <Button color="outline" onClick={this.enableDKIM} loading={this.state.isEnabling}>
            button.enableDKIM
          </Button>
        </div>
      </div>
    );
  };

  renderEnabled = () => {
    return (
      <div className="sectionSP">
        <div className="infoSectionSP">
          <div className="settingTitle">{t("settings.sections.dkim.title")}</div>
          <div className="sectionDesc">{t("settings.sections.dkim.desc")}</div>
        </div>
        <div className="formsSectionSP">
          <div className={cx(s.infoText, "inputFull2")}>{t("description.text.enabledDKIM")}</div>
          <Button color="red-outline" onClick={this.disableDKIM} loading={this.state.isDisabling}>
            button.disableDKIM
          </Button>
        </div>
      </div>
    );
  };

  renderWaitingVerification = (selector, txtRecord) => {
    return (
      <div className="sectionSP">
        <div className="infoSectionSP">
          <div className="settingTitle">{t("settings.sections.dkim.title")}</div>
          <div className="sectionDesc">{t("settings.sections.dkim.desc")}</div>
        </div>
        <div className="formsSectionSP">
          <div className={cx(s.infoText, "inputFull2")}>{t("infoMsg.DKIMInstruction")}</div>
          <div className={cx(s.txtRecord, "inputFull2")}>
            <pre>{selector}</pre>
            <pre>{txtRecord}</pre>
          </div>
          <div className={s.wrapBtn}>
            <Button color="outline" onClick={this.resetDKIM} loading={this.state.isResetting}>
              button.resetProcedure
            </Button>
            <Button onClick={this.verifyDKIM} loading={this.state.isVerifing}>
              button.verifyDKIM
            </Button>
          </div>
        </div>
      </div>
    );
  };

  renderEnqueued = (isDeleting) => {
    return (
      <div className="sectionSP">
        <div className="infoSectionSP">
          <div className="settingTitle">{t("settings.sections.dkim.title")}</div>
          <div className="sectionDesc">{t("settings.sections.dkim.desc")}</div>
        </div>
        <div className="formsSectionSP">
          <div className={cx(s.infoText, "inputFull2")}>
            <Loader inLine msg={isDeleting ? t("settings.msg.dkim.disabling") : t("settings.msg.dkim.activating")} />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const domain = this.props.domain;

    if (domain.has_dkim === 1) {
      return this.renderEnabled();
    } else if (domain.has_dkim === 2) {
      return this.renderWaitingVerification(domain.dkim_selector, domain.dkim_public_key);
    } else if (domain.has_dkim === 3 || domain.has_dkim === 4) {
      return this.renderEnqueued(domain.has_dkim === 4);
    }

    return this.renderDisabled();
  }
}
